export class PaginationList<T> {
  constructor(
    public items: Array<T> = [],
    public totalItems: number = 0,
    public limit: number = null
  ) { }
}



// WEBPACK FOOTER //
// /dist/src/app/shared/grid/pagination-list.model.ts